const DEFAULT_MESSAGE = "다시 로그인하세요.";
export const SESSION_EXPIRED_EVENT = "xi-session-expired";

const createEvent = (message) => {
  const detail = { message: String(message || DEFAULT_MESSAGE) };
  if (typeof window === "undefined") return null;

  if (typeof window.CustomEvent === "function") {
    return new CustomEvent(SESSION_EXPIRED_EVENT, { detail });
  }

  const event = document.createEvent("CustomEvent");
  event.initCustomEvent(SESSION_EXPIRED_EVENT, false, false, detail);
  return event;
};

export function notifySessionExpired(message) {
  const event = createEvent(message);
  if (!event) return;
  window.dispatchEvent(event);
}
